import { useMutation } from "@tanstack/react-query"

import type { UseCaseFormData } from "../types/use-case.types"

import { aiDraftAssist } from "../api/use-cases-api"

export function useAiDraftAssist() {
  return useMutation({
    mutationFn: ({
      useCaseData,
      targetField,
    }: {
      useCaseData: Partial<UseCaseFormData>
      targetField: string
    }) => aiDraftAssist(useCaseData, targetField),
  })
}
